import { SegmentModel } from '../SegmentModel';
import { SerialisableModel } from '../Model';
export class EntityModel extends SerialisableModel {
    static from(data) {
        return new EntityModel(data);
    }
    get id() {
        return this.data.entity_id;
    }
    get name() {
        return this.data.name;
    }
    get onboardsSubEntities() {
        return this.data.onboards_sub_entities;
    }
    get entitySegments() {
        //need to backfill in entity_id as it is no longer provided on the segment object via the client selector api
        // eslint-disable-next-line @typescript-eslint/naming-convention
        const { entity_id } = this.data;
        return this.data.entity_segments
            ? this.data.entity_segments.map((entity_segment) => SegmentModel.from({ ...entity_segment, entity_id }))
            : [];
    }
    get timeZone() {
        return this.data.timezone ? this.data.timezone : undefined;
    }
    get status() {
        return this.data?.status;
    }
}
